import * as customerMocks from './mocks';
// Used as the key for this domain in HostData (@ally/data-types-host)
export var DOMAIN_NAME = 'afgCustomer';
export * from './types';
export { customerMocks };
//# sourceMappingURL=index.js.map